var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlagCheckered(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.0875 3.8255C20.9618 3.76546 20.8221 3.74072 20.6834 3.75393C20.5447 3.76714 20.4121 3.8178 20.3 3.9005C17.6469 5.888 15.3969 4.93175 12.8 3.81612C10.2031 2.7005 7.14688 1.388 3.8 3.9005C3.70685 3.97036 3.63125 4.06095 3.57918 4.16509C3.52711 4.26923 3.5 4.38406 3.5 4.5005V20.2505C3.5 20.4494 3.57902 20.6402 3.71967 20.7808C3.86032 20.9215 4.05109 21.0005 4.25 21.0005C4.44891 21.0005 4.63968 20.9215 4.78033 20.7808C4.92098 20.6402 5 20.4494 5 20.2505V16.1349C7.52187 14.438 9.69688 15.3661 12.2 16.4442C13.7281 17.0911 15.3687 17.7942 17.1312 17.7942C18.425 17.7942 19.7844 17.4192 21.2 16.3505C21.2926 16.2801 21.3678 16.1895 21.4198 16.0854C21.4719 15.9814 21.4993 15.8668 21.5 15.7505V4.5005C21.4989 4.36117 21.4599 4.22476 21.3872 4.10587C21.3146 3.98697 21.211 3.89006 21.0875 3.8255ZM15.125 15.9661V10.9505C13.3531 10.4442 11.6469 9.45987 9.875 8.95362V13.9786C8.34688 13.5849 6.725 13.5286 5 14.4005V9.4505C6.71562 8.45675 8.31875 8.513 9.875 8.95362V4.28487C10.666 4.54533 11.4422 4.84891 12.2 5.19425C13.1375 5.588 14.1125 6.00987 15.125 6.27237V10.9505C16.6812 11.3911 18.2844 11.4474 20 10.4536V15.3661C18.2844 16.5192 16.7281 16.463 15.125 15.9661Z",
    fill: "white",
    fillOpacity: 0.6
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagCheckered);
export default __webpack_public_path__ + "static/media/FlagCheckered.7edeb32b1c83e4393812d06f6d15bd9d.svg";
export { ForwardRef as ReactComponent };